export default {
  newDesign: true,
  title: "Ответьте на 4 вопроса и получите приглашение на БЕСПЛАТНЫЙ IT-КУРС для ребёнка | Kodland",
  downtimeUrl: "https://www.kodland.org/ru",
  parameters: {
    landing_id: "CisQITp2",
    segment: 1,
    success_page: 'cis_freetc_thankyou',
  },
  startPage: {
    title:
      "Ответьте на 4 вопроса и получите приглашение на БЕСПЛАТНЫЙ IT-КУРС для ребёнка",
    subtitle:
      "Вместе сделаем игру и покажем как превратить увлечение гаджетами в пользу на БЕСПЛАТНОМ онлайн-курсе программирования",
    image: {
      url: "/welcome/cis_it_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/cis_it_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Вперёд 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Спасибо, что доверяете нашей образовательной платформе!",
    subtitle:
      "К сожалению, планшеты и телефоны не подходят для прохождения наших уроков. Будем рады видеть вас на наших занятиях в следующий раз!",
  },
  quizRotateBySteps: {
    1: {
      question: "Сколько времени ребёнок проводит с гаджетами в день?",
      answers: [
        "😍 До 2-х часов",
        "😒 От 2-х до 4-х часов",
        "😔 Больше 4-х часов",
        "🤔 Не слежу за этим"
      ],
    },
    2: {
      question: "Какой характер у вашего ребёнка? Ответ поможет подобрать нам подходящего методиста для ребенка",
      answers: [
        "🗣️ Активный, много общается",
        "🐭 Застенчивый, часто зажимается",
        "⛅ Мечтательный, витает в облаках",
        "🙂 Тихоня, проводит время «в себе»",
        "🤔 Не знает, чего хочет",
        "😏 Свой вариант (расскажу на уроке)"
      ],
    },
    3: {
      question: "Как вы оцениваете мотивацию ребёнка учиться?",
      answers: [
        "😞 Низкая мотивация",
        "🙂 Нормальная",
        "😍 Высокая"
      ],
    },
    4: {
      title: "Сколько лет вашему ребёнку?",
      type: "age",
      button: "",
    },
    5: {
      question:
        "У вас есть компьютер или ноутбук? (для обучения не подойдут телефоны, планшеты и устройства без клавиатуры и мыши)",
      answers: [
        "😉 Да",
        {
          answer: "🤔 Нет",
          stopAnswer: true,
        },
      ],
    },
    6: {
      question: "Как вы думаете,  что ребёнку будет интереснее всего изучать и создавать на бесплатном курсе?",
      answers: [
        "🎨 Рисовать иллюстрации для игр, кино, приложений",
        "🤖 Создавать авторские анимации с 3D-моделями и иллюстрациями",
        "💻 Создавать и размещать сайты в интернете (портфолио, визитка)",
        "🎮 Создать свою игру, которая будет популярна в интернете",
        "🛠 Создать приложение, которое будет помогать людям в жизни",
      ],
    },
    7: {
      title: "Поздравляем! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Чтобы завершить регистрацию на бесплатный онлайн-курс, выберите дату и время для первого урока.",
      button: "Выбрать дату",
    },
    8: {
      title: "Завершите регистрацию",
      type: "one-page-contacts",
      subtitle: "",
      button: "Последний шаг 🔥",
    },
    9: {
      title: "Выберите удобный день для первого урока",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    10: {
      title: "Просмотрите внимательно эту информацию, чтобы завершить регистрацию ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Для урока вам понадобится компьютер или ноутбук со стабильным интернетом. Пожалуйста, будьте рядом с ребёнком во время занятия. Формат занятий индивидуальный.",
      button: "Супер 🔥",
    },
    11: {
      title: "Проверьте электронную почту и WhatsApp перед профильным уроком 📞",
      typeInfo: "whatsapp",
      subtitle:
        "За 24 часа до занятия мы пришлём вам напоминание, а за 2 часа попросим подтвердить своё участие. Очень важно оставаться на связи, чтобы занятие не было отменено.",
      button: "Договорились 👌",
    },
    12: {
      title: "Урок пройдет на нашей платформе 💻",
      typeInfo: "classroom",
      subtitle:
        "Вы получите ссылку и уникальный код через WhatsApp и email. Просто нажмите на ссылку, и вы сразу попадёте на урок. Никаких дополнительных приложений не нужно.",
      button: "Понятно ✅",
    },
  },
};
